<template>
    <div class="img-picker-pagination clearfix">
        <div
            v-if="total"
            class="img-picker-pagination-total"
        >
            {{ text }}
        </div>
        <v-pagination
            :total="total"
            :count="count"
            @change="onChange"
            style="float: right;"
        />
    </div>
</template>

<script>
export default {
    name: 'ReplyPagination',
    props: {
        total: {
            type: Number,
            default: 0,
        },
        count: {
            type: Number,
            default: 15,
        },
        text: {
            type: String,
            default: '',
        },
    },
    methods: {
        onChange(page) {
            this.$emit('change', page);
        },
    },
};
</script>

<style>
.img-picker-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 15px;
    border: none;
    background-color: #edeff2;
}

.img-picker-pagination .v-pagination__total {
    display: none;
}

.img-picker-pagination-total {
    float: left;
    line-height: 30px;
}
</style>

<style lang="less" scoped>
.v-pagination {
    padding: 0;
}
</style>
